import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import PlatformSectionTitle from './components/PlatformSectionTitle'
import PlatformNavLink from './components/PlatformNavLink'
import NavGrid from 'components/NavGrid'
import Section from './components/Section'
import StyledSection from './components/StyledSection'
import SectionByline from './components/SectionByline'
import SectionHeadline from './components/SectionHeadline'
import SectionIntro from './components/SectionIntro'
import {
  Container,
  withTheme,
  SecondaryLink,
  spacer,
  typography
} from 'stylist'
import platforms from 'config/platforms'
import { prop } from 'utils/fp'

const LearnMoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacer(8)};

  ${SecondaryLink} {
    ${typography('body3Medium')};
  }
`

const RouteHomeIndex = ({ match: { path }, theme }) => (
  <Fragment>
    <Section background="ink">
      <Container>
        <NavGrid>
          <PlatformSectionTitle>My Forsta</PlatformSectionTitle>
          {platforms
            .filter(prop('displayOnHomepage'))
            .map(platform => (
              <PlatformNavLink key={platform.id} platform={platform} />
            ))}
        </NavGrid>
      </Container>
    </Section>
    <StyledSection background="white">
      <Container>
        <SectionIntro>
          <SectionHeadline>
            Every challenge has a solution.<br />
            It depends on your question.
          </SectionHeadline>
          <SectionByline>
            No matter your role, research can help your business.
          </SectionByline>
          <LearnMoreButtonContainer>
            <SecondaryLink
              external
              href="https://www.forsta.com/solutions/"
            >
              Explore Forsta solutions
            </SecondaryLink>
          </LearnMoreButtonContainer>
        </SectionIntro>
      </Container>
    </StyledSection>
  </Fragment>
)

export default withTheme(RouteHomeIndex)



// WEBPACK FOOTER //
// ./src/routes/home/index.js